import React, { useState } from 'react'
import StyledInput from '../../Commons/StyledInput'
import { useNavigate } from 'react-router-dom'

const PayingCenterListComponent = ({ payingCenters, totalItems }) => {
    const navigate = useNavigate()
    const [searchTerm, setSearchTerm] = useState('')

    const filteredCenters = payingCenters.filter((center) =>
        Object.entries(center).some(([key, value]) => {
            // Ignore les champs id et autres champs non pertinents pour la recherche
            if (key === 'id') return false

            // Vérifier si la valeur est null ou undefined
            if (value == null) return false

            // Convertir en chaîne de caractères et comparer
            return value
                .toString()
                .toLowerCase()
                .includes(searchTerm.toLowerCase())
        })
    )

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-bold">Liste de vos caisses</h1>
                <div className="flex items-center space-x-4">
                    <StyledInput
                        type="text"
                        placeholder="Rechercher..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <div className="flex items-center">
                        <p className="mr-1 text-sm text-gray-500">Total</p>
                        <p className="text-sm font-bold text-gray-500">
                            {totalItems}
                        </p>
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-1 gap-4">
                {filteredCenters.map((payingCenter) => (
                    <div
                        key={payingCenter.id}
                        onClick={() => {
                            navigate(`/ressources/caisses/${payingCenter.id}`)
                        }}
                        className="rounded-lg bg-white p-6 shadow-md transition-shadow duration-300 hover:shadow-lg"
                    >
                        <div className="flex flex-col space-y-4 sm:flex-row sm:items-center sm:justify-between sm:space-y-0">
                            <div className="flex-1">
                                <p className=" font-bold">
                                    {payingCenter.label}
                                </p>
                                <p className="text-sm text-gray-500">
                                    Régime {payingCenter.codeRegime}
                                </p>
                            </div>
                            <div className="flex-1">
                                <p className="text-sm font-medium">
                                    Centre gestionnaire
                                </p>
                                <p className="text-sm text-gray-500">
                                    {payingCenter.codeCentreGestionnaire}
                                </p>
                            </div>
                            <div className="flex-1">
                                <p className="text-sm font-medium">
                                    Centre informatique
                                </p>
                                <p className="text-sm text-gray-500">
                                    {payingCenter.codeCentreInformatique}
                                </p>
                            </div>
                            <div className="flex-1">
                                <p className="text-sm font-medium">
                                    Organisme destinataire
                                </p>
                                <p className="text-sm text-gray-500">
                                    {payingCenter.organismeDestinataire}
                                </p>
                            </div>
                            <div className="flex-1">
                                <p className="text-sm">
                                    {payingCenter.lastGroupId ? (
                                        <>
                                            Dernier lot{' '}
                                            <span className="font-semibold">
                                                {payingCenter.lastGroupId}
                                            </span>
                                        </>
                                    ) : (
                                        'Aucun lot'
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default PayingCenterListComponent
